import { BsNewspaper, BsFillTelephoneFill } from "react-icons/bs";
import { FcCustomerSupport } from "react-icons/fc";

const supportLinks = [
  {
    name: "Contact a specialist",
    href: "#",
    description:
      "Wondering if Buyist is the right tool for your business? Chat with our team to see if there’s a fit. ",
    icon: BsFillTelephoneFill,
  },
  {
    name: "Technical Support",
    href: "#",
    description:
      "Looking for help in the builder or have questions about your existing account? Chat with a real human from our award-winning customer success team, or see our Help Center.",
    icon: FcCustomerSupport,
  },
  {
    name: "Media Inquiries",
    href: "#",
    description:
      "We love working with journalists to share compelling stories. Send us a note and our PR and Communications Manager will be in touch.",
    icon: BsNewspaper,
  },
];

export default function Example() {
  return (
    <div className="bg-white">
      <div className="  max-w-md mx-auto  px-4 pb-32 sm:max-w-3xl sm:px-6 md:mt-32 lg:max-w-7xl lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-black md:text-5xl lg:text-6xl mb-32">
          Support
        </h1>
      </div>

      <main>
        <div className="bg-blue-gray-50">
          {/* Cards */}
          <section
            className="-mt-32 max-w-md mx-auto relative z-10 px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
            aria-labelledby="contact-heading"
          >
            <h2 className="sr-only" id="contact-heading">
              Contact us
            </h2>
            <div className="mb-20 grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
              {supportLinks.map((link) => (
                <div
                  key={link.name}
                  className="bg-blue-100 rounded-2xl shadow-xl"
                >
                  <div className="relative pt-16 px-6 pb-8 md:px-8">
                    <div className="absolute top-0 p-5 inline-block bg-blue-600 rounded-xl shadow-lg transform -translate-y-1/2">
                      <link.icon className="h-6 w-6 text-white" />
                    </div>
                    <h3 className="text-xl font-medium text-blue-gray-900">
                      {link.name}
                    </h3>
                    <p className="mt-4 text-base text-blue-gray-500">
                      {link.description}
                    </p>
                  </div>
                  <div className="p-6 bg-blue-gray-50 rounded-bl-2xl rounded-br-2xl md:px-8">
                    <a
                      href={link.href}
                      className="text-base font-medium text-blue-700 hover:text-blue-600"
                    >
                      Contact us
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
